var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-pbi',{attrs:{"report-id":"a2e21dce-c93f-4b7d-9471-2bd261a07f4b","group-id":"5de7d4a7-b0d1-41a8-a978-693e831cfdcd"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }